import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

const getRoles = function(state:RootState) {
    return state?.role?.roles?.data;
};

const getUsers = function(state:RootState) {
    return state?.user;
};



export const  getUserrDetails = createSelector(getUsers,getRoles,(user, roles)=>{
    const getRole =(id: string)=> roles?.find((role)=> role?.roleId === id)
    const modifyData = {
        ...user,
        users:{
            ...user?.users,
            data: user?.users?.data?.map((user)=>({...user, role: getRole(user?.roleId)}))
        }
    }
    return modifyData
})

